module.exports = __webpack_public_path__ + "static/media/icon_share.291d72b6.svg";